import {
  AuthorizeRequestPayload,
  AuthorizeResponsePayload,
  VAIR_AUTHORIZE_API_ROUTE,
  VAIR_AUTHORIZE_SIGNIN_MODE,
} from 'constants/payloads/vair/authorize';
import {
  ExchangeResponsePayload,
  VAIR_SIGNIN_COMPLETE_API_ROUTE,
  VAIR_SIGNIN_EXCHANGE_API_ROUTE,
} from 'constants/payloads/vair/signin';
import api from 'services/client/api';
import { StatePayloadValue, persistStatePayload } from 'services/client/oauthStatePayload';

/**
 * Asks the server for VAIR's consent URL, then hands the browser over to it. The route seals
 * the flow state in a cookie; in link mode it takes the account from the caller's auth token,
 * which is why this is a POST through `api` and not a plain navigation.
 */
const redirectToVairAuthorize = async (payload: AuthorizeRequestPayload) => {
  const { authorizationUrl }: AuthorizeResponsePayload = await api.post(
    VAIR_AUTHORIZE_API_ROUTE,
    { payload, credentials: 'include' },
  );

  window.location.href = authorizationUrl;
};

/** Connects VAIR to the signed-in user's account. */
export const connectVairAccount = (returnTo?: string) => redirectToVairAuthorize({ returnTo });

interface StartVairSignInOptions {
  /** Same shape Google/Facebook use; ModalCompleteProfile reads it back for new users. */
  statePayload?: Record<string, StatePayloadValue>;
  returnTo?: string;
}

export const startVairSignIn = ({ statePayload, returnTo }: StartVairSignInOptions) => {
  persistStatePayload(statePayload);
  return redirectToVairAuthorize({ mode: VAIR_AUTHORIZE_SIGNIN_MODE, returnTo });
};

// Both routes read the callback's HttpOnly cookies, hence `credentials`.
export const exchangeVairSignInToken = (): Promise<ExchangeResponsePayload> =>
  api.post(VAIR_SIGNIN_EXCHANGE_API_ROUTE, { credentials: 'include' });

export const completeVairSignIn = async (): Promise<void> => {
  await api.post(VAIR_SIGNIN_COMPLETE_API_ROUTE, { credentials: 'include' });
};
